import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { listTenants, type Tenant } from '../api/tenants.js';

/**
 * Resuelve el `slug` de un tenant a partir de un id-o-slug en el URL.
 * El backend de flow-engine guarda flows con tenantId=slug literal, mientras
 * que tenant-mgmt acepta ambos. Cuando el URL del SPA trae UUID (porque el
 * topbar dropdown navega con id interno), necesitamos convertir a slug antes
 * de llamar al flow-engine.
 *
 * Devuelve el input tal cual si no encuentra match (fail-open).
 */
export function useTenantSlug(idOrSlug: string): string {
  const { data } = useQuery({
    queryKey: ['tenants', 'all-for-slug-lookup'],
    queryFn: () => listTenants({ limit: 100 }),
    staleTime: 60_000,
  });
  return useMemo(() => {
    const tenants: Tenant[] = data?.items ?? [];
    const found = tenants.find((t) => t.id === idOrSlug || t.slug === idOrSlug);
    return found?.slug ?? idOrSlug;
  }, [data, idOrSlug]);
}
